import parse from "html-react-parser";
import cx from "classnames";

// Components
import Section from "../Section/SectionContainer";
import Button from "../Button/ButtonContainer";

// CSS
import styles from "./welcome.module.scss";

/**
 * Constants
 */

const Welcome = (data) => {
    const {
        welcome_background_left,
        welcome_background_right,
        welcome_message,
        cta_link,
        cta_text,
    } = data;

    /**
     * Hooks
     */

    return (
        <Section
            classes={styles["welcome"]}
            style={{
                backgroundImage: `
                  url(${welcome_background_left?.sizes?.medium_large}),
                  url(${welcome_background_right?.sizes?.medium_large})
              `,
            }}
        >
            <div className={styles.welcome_message}>
                {welcome_message && <span>{parse(data.welcome_message)}</span>}

            </div>

            <a
                href={cta_link}
                rel="noreferrer"
                target="_blank"
                className={cx(styles.welcome_cta, {
                    [styles["welcome_cta--hidden"]]: !cta_link,
                })}

            >
                <Button
                    className={styles.button}
                    text={cta_text} />
            </a>
        </Section>
    );
};

export default Welcome;
